<template>
    <div class="one">
        <a href="https://job.hdymxy.com/redirect?type=activity&id=314"><img src="../images/cp1.png" class="swiper-img"/></a>
        <Title></Title>
        <img class="one-img" src="../images/p1.png" alt/>
        <div class="two-items">
            <img src="../images/p2.png" alt class="two-img"/>
            <img src="../images/p22.png" alt class="two-img"/>
        </div>
        <Title>
            <template v-slot:index>
                <div class="t1">
                    <span class="index">2</span>
                    <span class="big-font">梦幻海豚湾</span>--海洋小可爱的乐园
                </div>
            </template>
            <template v-slot:xc>
                <div class="t2">
                    <span class="xc">秋季行程</span>海豚馆、水母宫殿、珊瑚、鲨鱼馆、海豹喂养
                </div>
            </template>
        </Title>
        <img src="../images/p3.png" class="one-img" alt="">
        <div class="two-items">
            <div class="cover-box"><img src="../images/p44.png" alt="" class="two-img">
                <div class="content-box">喂养海豹海狮</div>
            </div>
            <div class="cover-box">
                <div class="content-box">近距离观察珊瑚.鲨鱼.水母</div>
                <img src="../images/p4.png" alt="" class="two-img"></div>
        </div>
        <Title>
            <template v-slot:index>
                <div class="t1">
                    <span class="index">3</span>
                    <span class="big-font">实景穿越元明清</span>--拍一组亲子写真
                </div>
            </template>
            <template v-slot:xc>
                <div class="t2">
                    <span class="xc">秋季行程</span>实景拍摄地、景色自由选、各种角色自由切换...
                </div>
            </template>
        </Title>
        <div class="cover-box">
            <div class="content-box">
                清明上河图——轩廊水榭，亭台花坊
            </div>
            <img src="../images/p5.png" alt="" class="one-img"></div>
        <div class="two-items">
            <img src="../images/p6.png" alt="" class="two-img">
            <img src="../images/p66.png" alt="" class="two-img">
        </div>
        <div class="cover-box">
            <div class="content-box">
                明清宫苑——姹紫嫣红，1:1复刻的紫禁城
            </div>
            <img src="../images/p77.png" alt="" class="one-img"></div>
        <div class="two-items">
            <img src="../images/p8.png" alt="" class="two-img">
            <img src="../images/p88.png" alt="" class="two-img">
        </div>
        <div class="cover-box">
            <div class="content-box">
                梦外滩——醉生梦死，十里洋场老上海
            </div>
            <img src="../images/p9.png" alt="" class="one-img"></div>
        <div class="two-items">
            <img src="../images/t1.png" alt="" class="two-img">
            <div class="cover-box">
                <div class="content-box">
                    坐趟“有轨电车之旅”
                </div>
                <img src="../images/t11.png" alt="" class="two-img"></div>
        </div>
        <Title style="height: 27vw">
            <template v-slot:index>
                <div class="t1">
                    <span class="index">4</span>
                    <span class="big-font">百老汇大厦</span>--亲子主题房
                </div>
            </template>
            <template v-slot:xc>
                <div class="t2">
                    推荐入住亲子主题房，和家人度过一个愉快的
                    周末！酒店仿建1934年“上海大厦”，还原旧
                    时老上海风格，带您沉浸在影视氛围中。
                </div>
            </template>
        </Title>
        <img src="../images/t2.png" alt="" class="one-img">
        <div class="two-items">
            <img src="../images/t3.png" alt="" class="two-img">
            <img src="../images/t33.png" alt="" class="two-img">
        </div>
        <img src="../images/t4.png" alt="" class="one-img">
        <img src="../images/t5.png" alt="" class="one-img">
    </div>
</template>

<script>
    import Title from "../components/Title";

    export default {
        components: {
            Title
        }
    };
</script>

<style lang="stylus" scoped>
    .one
        display flex
        flex-direction column
        align-items center
        background-color #CEAEA5

        .two-items
            display flex
            justify-content space-between
            width 92.8vw
</style>